<template>
  <form name="roadmaps-form" @submit.prevent="$emit('save')">
    <BLayoutExpansion title="Основное" class="my-4">
      <v-row dense>
        <v-col sm="8" lg="6">
          <BTextField
            v-model="form.name"
            validate="required"
            label="Название"
            :disabled="isView"
            :skeleton="skeleton"
            name="name"
            autofocus
          />
        </v-col>
        <v-col align-self="center">
          <v-skeleton-loader :loading="skeleton" type="sentences">
            <v-checkbox
              v-model="form.is_published"
              :indeterminate="form.is_published === void 0"
              :disabled="isView"
              label="Опубликована?"
              dense
              hide-details
              class="pa-0 ma-0"
              name="is_published"
            />
          </v-skeleton-loader>
        </v-col>
        <v-col align-self="center">
          <v-skeleton-loader :loading="skeleton" type="sentences">
            <v-tooltip v-if="form.is_updated" bottom>
              <template #activator="{ on }">
                <div v-on="on">
                  <v-icon color="success">
                    mdi-checkbox-marked-outline
                  </v-icon>
                  <span
                    class="cursor-default"
                    v-text="' Обновлено'"
                  />
                </div>
              </template>
              <div
                style="max-width: 300px;"
                v-text="'Дорожная карта синхронизирована в Личном кабинете и доступна у всех ОО'"
              />
            </v-tooltip>
            <v-tooltip v-else bottom>
              <template #activator="{ on }">
                <div class="cursor-default" v-on="on">
                  <v-icon color="error">
                    mdi-close-circle-outline
                  </v-icon>
                  Обновление
                </div>
              </template>
              <div style="max-width: 320px;">
                Дорожная карта ещё не синхронизирована в Личном кабинете и может быть недоступна у части ОО
              </div>
            </v-tooltip>
          </v-skeleton-loader>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12">
          <BTextarea
            v-model="form.description"
            label="Описание"
            :disabled="isView"
            :skeleton="skeleton"
            name="description"
            counter
          />
        </v-col>
      </v-row>

      <v-row v-if="!isCreate" dense>
        <v-col :cols="!skeleton && 'auto'">
          <BTextField
            :value="data.created_at | dateFormatter"
            :skeleton="skeleton"
            label="Создан"
            disabled
          />
        </v-col>

        <v-col :cols="!skeleton && 'auto'">
          <BTextField
            :value="data.updated_at | dateFormatter"
            :skeleton="skeleton"
            label="Обновлен"
            disabled
          />
        </v-col>
      </v-row>
    </BLayoutExpansion>

    <div v-if="$scopedSlots.directions" class="mb-4">
      <slot name="directions" />
    </div>

    <BLayoutExpansion title="Дерево ATE" class="mb-4">
      <BAteTree
        :regions.sync="form.regions"
        :municipalities.sync="form.municipalities"
        :schools.sync="form.schools"
        :readonly="isView"
        :skeleton="skeleton"
        model="Roadmap"
        default-collapsed
        style="margin: 0 -20px -8px;"
      />
    </BLayoutExpansion>

    <button type="submit" class="d-none" />
  </form>
</template>

<script>
import BLayoutForm from '@/components/layouts/BLayoutForm.vue'
import BLayoutExpansion from '@/components/layouts/BLayoutExpansion.vue'
import BTextField from '@/components/forms/BTextField.vue'
import BTextarea from '@/components/forms/BTextarea.vue'
import BAteTree from '@/components/forms/BAteTree.vue'


const createDefaultData = () => ({
  // id
  name: '',
  is_published: false,
  description: '',
  regions: [],
  municipalities: [],
  schools: [],
  // created_at
  // updated_at
})

export default {
  name: 'RoadmapsForm',
  components: {
    BLayoutExpansion,
    BTextField,
    BTextarea,
    BAteTree,
  },
  extends: BLayoutForm,
  props: {
    skeleton: Boolean,
    data: {
      type: Object,
      required: true,
      default: createDefaultData,
    },
  },
  methods: {
    async onSubmit() {
      const result = await this.$validator.validate()

      if (!result) {
        this.$notice.validatorFormError(this)
        const message = `Error submit: ${this.$options.name}`
        const error = new Error(message)
        return Promise.reject(error)
      }

      const { form } = this

      const data = {
        ...form,

        regions: void 0,
        region_ids: form.regions?.map((_) => _.id),

        municipalities: void 0,
        municipality_ids: form.municipalities?.map((_) => _.id),

        schools: void 0,
        school_ids: form.schools?.map((_) => _.id),
      }

      this.$emit('submit', data)

      return data
    },
  },
}
</script>
